(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller(
      "VirtualFairCyberSessionsWaitlistController",
      VirtualFairCyberSessionsWaitlistController
    );
    VirtualFairCyberSessionsWaitlistController.$inject = [
    "VirtualFairService",
    "$timeout",
    "$uibModal",
    "cyberSessions"
  ];

  function VirtualFairCyberSessionsWaitlistController(
    VirtualFairService,
    $timeout,
    $uibModal,
    cyberSessions
  ) {
    var vm = this;
    vm.getVirtualFairs = getVirtualFairs;
    vm.getByFilter = getByFilter;
    vm.queryFlag = false;
    vm.virtualFairSelected = "";
    vm.virtualFairsData = [];
    vm.cyberSessions = cyberSessions;
    vm.cyberSessionsWhitelist = [];

    function getVirtualFairs() {
      vm.query = {};
      vm.query = {'upcoming': 1};
      VirtualFairService.getAll(vm.query).then(function (response) {
        vm.virtualFairs = response.data;
        vm.virtualFairs.unshift({
          id: -1,
          name: '-- ALL --'
        });
        vm.virtualFairSelected = -1;
      });
    }

    async function getByFilter() {
      vm.queryFlag = false;
      vm.query = {};
      vm.cyberSessionsData = [];
      if (vm.virtualFairSelected) {
        vm.query["virtual_fair_id"] = vm.virtualFairSelected;
      }
      VirtualFairService.getCyberSessionsWhitelistByReport(vm.query, true)
      .then(async function (response) {
        vm.queryFlag = true;
        vm.cyberSessionsWhitelist = response.data;
      });
    }

    function active() {
      vm.getVirtualFairs();
    }

    active();
  }
})();
